// extracted by mini-css-extract-plugin
module.exports = {"articleListHeading":"index-module--articleListHeading--1VRDL"};